import shuffle from 'shuffle-array'
import api from '../../api'

const state = {
  score: 0,
  answeredQuestions: [],
  playedHideAndSeek: [],
  foundHideAndSeek: [],
  totalTrueAnswers: 0,
  avatar: {},
  userName: '',
  factCards: [],
  factFiles: [],
  pastFoundFactCardsTotal: 0,
  pastFoundFactFilesTotal: 0,
  totalFactCards: {
    hideAndSeek: 0,
    nowYouSeeMe: 0,
    trueOrFalse: 0
  },
  totalFactFiles: {
    hideAndSeek: 0,
    nowYouSeeMe: 0,
    trueOrFalse: 0
  },
  uid: '',
  u: '',
  hideAndSeekLevel: 'easy'
}

const getters = {
  score (state) {
    return state.score
  },
  answeredQuestions (state) {
    return state.answeredQuestions
  },
  totalTrueAnswers (state) {
    return state.totalTrueAnswers
  },
  playedHideAndSeek (state) {
    return state.playedHideAndSeek
  },
  foundHideAndSeek (state) {
    return state.foundHideAndSeek
  },
  userName (state) {
    return state.userName
  },
  avatar (state) {
    return state.avatar
  },
  factCards (state) {
    return state.factCards
  },
  factFiles (state) {
    return state.factFiles
  },
  uid (state) {
    return state.uid
  },
  diffTotalFoundFactFiles (state) {
    return state.factCards.length - state.totalPastFoundFactCards
  },
  diffTotalFoundFactCards (state) {
    return state.factFiles.length - state.totalPastFoundFactFiles
  },
  totalFoundFactFiles (state) {
    return state.factCards.length
  },
  totalFoundFactCards (state) {
    return state.factFiles.length
  },
  hideAndSeekLevel (state) {
    return state.hideAndSeekLevel
  }
}

const actions = {
  setUser ({ commit }, userData) {
    return api.registerUser(userData).then((data) => {
      userData.u = data.u
      userData.uid = data.uid
      commit('setUser', userData)
      return true
    })
  },
  cardsUnlock (context, game) {
    const unlock = (limitFactCards, limitFactFiles) => {
      if (context.state.totalFactCards[game] < limitFactCards) {
        const card = shuffle(context.rootState.data.factCardsList.filter(card => !context.state.factCards.includes(card.ID)))[0]
        if (card) {
          context.commit('unlockFactCard', { game, ID: card.ID })
        }
      }
      if (context.state.totalFactFiles[game] < limitFactFiles) {
        const card = shuffle(context.rootState.data.factFilesList.filter(card => !context.state.factFiles.includes(card.ID)))[0]
        if (card) {
          context.commit('unlockFactFile', { game, ID: card.ID })
        }
      }
    }
    switch (game) {
      case 'trueOrFalse':
        unlock(2, 1)
        break
      case 'nowYouSeeMe':
        unlock(6, 3)
        break
      case 'hideAndSeek':
        unlock(6, 3)
        break
    }
  },
  addToScore (context, score) {
    context.commit('setScore', score)
    api.setS({ s: btoa(context.state.score), uid: context.state.uid, u: context.state.u })
  }
}

const mutations = {
  setScore (state, points) {
    state.score += points
  },
  setQuestionAnswered (state, id) {
    state.answeredQuestions.push(id)
  },
  setPlayedHideAndSeek (state, id) {
    state.playedHideAndSeek.push(id)
  },
  resetPlayedHideAndSeek (state) {
    state.playedHideAndSeek = []
    state.hideAndSeekLevel = 'easy'
  },
  setFoundHideAndSeek (state, id) {
    state.foundHideAndSeek.push(id)
  },
  addTotalTrueAnswers (state) {
    state.totalTrueAnswers++
  },
  setUser (state, data) {
    state.avatar = data.avatar
    state.userName = data.userName
    state.u = data.u
    state.uid = data.uid
  },
  unlockFactCard (state, data) {
    state.totalFactCards[data.game]++
    state.factCards.push(data.ID)
  },
  unlockFactFile (state, data) {
    state.totalFactFiles[data.game]++
    state.factFiles.push(data.ID)
  },
  setCardDiff (state) {
    state.totalPastFoundFactCards = state.factCards.length
    state.totalPastFoundFactFiles = state.factFiles.length
  },
  setNextHideAndSeekLevel (state) {
    switch (state.hideAndSeekLevel) {
      case 'easy':
        state.hideAndSeekLevel = 'medium'
        break
      case 'medium':
        state.hideAndSeekLevel = 'hard'
        break
      case 'hard':
        state.hideAndSeekLevel = 'easy'
        break
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
